import React from 'react';
import './EmptyStateComponent.scss';
import ScreenService from '../../services/ScreenService';

function getStaticImageUrl() {
    const hasEPG = window.__UpshowState && !!window.__UpshowState.settings.features.on_screen_menu;
    const hasLiveEvent = window.__UpshowState && !!window.__UpshowState.settings.features.live_events;
    if (ScreenService.isVertical) return 'https://cdn.upshow.tv/ui-assets/No_Content_Vertical_Screen.jpg';
    else if (hasEPG) return 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_EPG_Screen.png';
    else if (hasLiveEvent) return 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Horizontal_Live_Event.jpg';
    return 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Horizontal.jpg';
}

export default function EmptyStateComponent() {
    return (
        <div className='empty-state'>
            <img className='w-h-100' src={getStaticImageUrl()} alt='' />
        </div>
    );
}
